export function Contact() {

	this.companyName = null;
	this.companyIdNumber = null;
	this.companyTaxNumber = null;
	this.companyVatNumber = null;
	this.firstName = null;
	this.lastName = null;
	this.email = null;
	this.phone = null;
	this.address = null;
	this.zip = null;
	this.city = null;
	this.countryId = (window.country) ? window.country:1;
}